/*
  Preferiti MiniCharme.

  Niente app e niente account: la lista sta nel localStorage di chi guarda. In un catalogo da
  43.000 pezzi il problema vero non e' comprare, e' RITROVARE — uno apre venti schede, ne
  chiude diciannove e perde quella buona. Per questo basta il browser: chiedere di registrarsi
  per salvare un orecchino e' un prezzo piu' alto del problema che risolve.

  Si salvano solo gli HANDLE, non titolo e prezzo: una copia del prezzo invecchia in silenzio,
  e la pagina dei preferiti mostrerebbe una cifra che al carrello non esiste piu'. La pagina
  rilegge ogni prodotto da /products/<handle>.js, che e' una chiamata piccola e sempre vera.
*/
(function () {
  var CHIAVE = 'mc:preferiti';

  function leggi() {
    try {
      var v = JSON.parse(localStorage.getItem(CHIAVE) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      // localStorage puo' mancare o essere vietato (finestra anonima, cookie bloccati):
      // in quel caso i preferiti semplicemente non si ricordano, ma il sito non si rompe.
      return [];
    }
  }

  function scrivi(lista) {
    try { localStorage.setItem(CHIAVE, JSON.stringify(lista)); } catch (e) { /* pazienza */ }
    aggiornaConto(lista.length);
    document.dispatchEvent(new CustomEvent('mc:preferiti', { detail: lista }));
  }

  function aggiornaConto(n) {
    document.querySelectorAll('[data-mc-conto]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.hidden = n === 0;
    });
  }

  function segna() {
    var lista = leggi();
    document.querySelectorAll('[data-mc-cuore]').forEach(function (b) {
      var dentro = lista.indexOf(b.getAttribute('data-mc-cuore')) !== -1;
      b.setAttribute('aria-pressed', dentro ? 'true' : 'false');
      b.classList.toggle('mc-cuore--pieno', dentro);
    });
    aggiornaConto(lista.length);
  }

  // Delegato sul documento: le schede arrivano anche dopo (filtri, pagine successive), e un
  // ascoltatore per bottone si perderebbe tutte quelle nate dopo il caricamento.
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mc-cuore]') : null;
    if (!b) return;
    e.preventDefault();   // il cuore sta dentro il link della scheda
    e.stopPropagation();
    var h = b.getAttribute('data-mc-cuore');
    var lista = leggi();
    var i = lista.indexOf(h);
    if (i === -1) { lista.push(h); } else { lista.splice(i, 1); }
    scrivi(lista);
    segna();
  });

  document.addEventListener('DOMContentLoaded', segna);
  // Chi disegna schede DOPO il caricamento (il blocco "Mostrane altri") lancia questo evento:
  // senza, i cuori appena nati partono tutti vuoti anche su prodotti gia' salvati.
  document.addEventListener('mc:ridisegna', segna);
  if (document.readyState !== 'loading') segna();

  // --- la pagina dei preferiti ---------------------------------------------------------
  var contenitore = document.getElementById('mc-preferiti-lista');
  if (!contenitore) return;

  function soldi(centesimi, valuta) {
    var v = valuta || 'EUR';
    // it-IT con `style:'currency'` scrive "19,90 €", il negozio scrive "€19,90": due formati
    // nella stessa pagina fanno sembrare il prezzo di un'altra cosa. Per l'euro si compone a
    // mano; per ogni altra valuta si lascia fare a Intl, che almeno e' corretto.
    if (v === 'EUR') return '€' + (centesimi / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (centesimi / 100).toLocaleString('it-IT', { style: 'currency', currency: v });
  }

  function disegna() {
    var lista = leggi();
    if (!lista.length) {
      contenitore.innerHTML =
        '<p class="mc-pref__vuoto">Non hai ancora salvato niente. Il cuore sta sopra ogni foto: ' +
        'premilo mentre sfogli e i pezzi finiscono qui.</p>' +
        '<p><a class="button" href="/collections/all">Sfoglia il catalogo</a></p>';
      return;
    }
    contenitore.innerHTML = '<p class="mc-pref__caricando">Carico…</p>';
    Promise.all(lista.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (prodotti) {
      // Un prodotto tolto dal catalogo risponde 404: si toglie anche dalla lista, altrimenti
      // resta li' per sempre a fare da buco.
      var vivi = [];
      var html = '';
      prodotti.forEach(function (p, i) {
        if (!p) return;
        vivi.push(lista[i]);
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        html +=
          '<li class="mc-pref__item">' +
          '<a class="mc-pref__foto" href="/products/' + p.handle + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="300" height="300">' : '') +
          '</a>' +
          '<div class="mc-pref__testo">' +
          '<a class="mc-pref__nome" href="/products/' + p.handle + '">' + p.title + '</a>' +
          '<div class="mc-pref__prezzo">' + soldi(p.price, window.Shopify && window.Shopify.currency && window.Shopify.currency.active) + '</div>' +
          '<button type="button" class="mc-pref__togli" data-mc-cuore="' + p.handle + '">Togli dai preferiti</button>' +
          '</div></li>';
      });
      if (vivi.length !== lista.length) { scrivi(vivi); return; }   // scrivi ridisegna da solo
      contenitore.innerHTML = '<ul class="mc-pref__griglia">' + html + '</ul>';
      segna();
    });
  }

  document.addEventListener('mc:preferiti', disegna);
  disegna();
})();
